module.exports = __webpack_public_path__ + "img/alarm-warning-dent-red.4d1826ad.svg";